import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { Pagination } from '../../components/Pagination';
import { useNavigate, useParams } from 'react-router-dom';
import useQueryString from '../../../utils/hooks/useQueryString';
import { StoryViewItem } from './StoryViewItem';
import { useQuery } from "@tanstack/react-query";
import Api from 'utils/api/Api';
const queryString = require('query-string');

/**
 * 특정 이용자의 동화서당 글 목록
 * @returns 
 */
export const StoryListByUser = () => {
  const navigate = useNavigate();
  const { school } = useParams();

  const auth = useSelector(state => state.auth);
  const { page } = useQueryString();

  const { data:storyList} = useQuery({
    queryKey:['donghwa/stories/user', page],
    queryFn:()=>Api.post(`/api/dongwha/story/list?page=${page}&sort=id,desc&size=5`, {user:'Y'})
  });

  const fetchList = useCallback((page = 0) => {
    let tempSearchOption = { page:page };
    navigate(`/${school}/user/${auth.id}/dongwha?${queryString.stringify(tempSearchOption)}`);
  }, [auth, navigate, school]);

  return(
    <div className="subpage">
      
      <div id="contents" className="mypage myreading_dongwha">
          <div className="section">
              <div className="inner">
                  <div className="activity_list dongwha_writer bdT0">

                    {
                      storyList?.data?.list.map((story) => {
                        return (
                          <div className="donghwaPage" key={story.id}>
                            <div className="topicPage">
                              <StoryViewItem story={story}/>
                            </div>
                          </div>
                        );
                    })
                    }
                  </div>
              </div>
          </div>
      </div>
      { storyList?.data?.list?.length<=0 && <div className="no_data"><p>목록이 없습니다.</p></div> }
      <Pagination page={storyList?.data?.page} totalPage={storyList?.data?.totalPages} gotoPage={fetchList}/>
    </div>
  );
};